import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { NotifyService } from '../services/notify.service';
import * as _ from 'lodash';
import { FlowService } from '../services/flow.service';


export interface CanComponentDeactivate {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class FlowGuard  {

    private _subject: Subject<any>;
    observer: Observable<any>;
    nameSession: string;
    exceptions:any = [
        'works => pais',
        'works => works',
        'pais => works',
        'pais => pais'
    ];

    constructor(private notifyService: NotifyService,
        private flowService: FlowService) {
        this._subject = new Subject<any>();
        this.observer = this._subject.asObservable();
        this.notifyService.observer.subscribe((response) => {
            if (response.key === 'changeModalConfirmation') {
                if (response.data) {
                    sessionStorage.removeItem(this.nameSession);
                }
                this.notifyFlow(response.data);
                this.notifyService.notify({ key: 'changeModalVisibility', data: false });
            }
        });
    }
    canDeactivate(component: CanComponentDeactivate,
        route: ActivatedRouteSnapshot, currentState: RouterStateSnapshot,
        nextState: RouterStateSnapshot) {
        this.nameSession = route.data.flow;
        const isException = this.checkExceptions(currentState, nextState);

        if (!isException && this.flowService.getUnsaved()) {
            this.notifyService.notify({ key: 'changeModalVisibility', data: true, modal: { title: "FLOW.TITLE", question: "FLOW.QUESTION", subquestion: "FLOW.SUBQUESTION" } });
            return this.observer;
        }
        // if (sessionStorage.getItem(this.nameSession) && !match) {            
        //     this.notifyService.notify({ key: 'changeModalVisibility', data: true,modal:{title:"FLOW.TITLE",question:"FLOW.QUESTION",subquestion:"FLOW.SUBQUESTION"} });
        //     return this.observer;
        // }
        return component.canDeactivate ? component.canDeactivate() : true;
    }

    notifyFlow(data) {
        this._subject.next(data);
    }

    checkExceptions(currentState, nextState) {
        const result = _.find(this.exceptions, (exception) => {
            const current = exception.split(' => ')[0];
            const next = exception.split(' => ')[1];
            if (_.includes(currentState.url, current) && _.includes(nextState.url, next)) {
                return true;
            }
        });

        return result ? result : false;
    }
}